var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubOffersgifticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7549 21.1592V42.2681C21.7549 42.2681 30.4781 36.1419 36.6044 34.344C36.6044 34.344 36.8707 21.2924 40.6664 14.7666L21.7549 21.1592Z",
    fill: "#076170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2158 39.0713C27.2158 39.0713 27.5488 20.3596 28.2147 19.4274C28.8806 18.4285 34.6073 17.4297 34.6073 17.4297C34.6073 17.4297 32.2766 34.9428 32.8094 36.0748C32.8759 36.0082 30.4787 37.0071 27.2158 39.0713Z",
    fill: "#B3690E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7552 42.2683C21.7552 42.2683 15.629 37.0743 6.10664 34.3441C6.10664 34.3441 6.83913 23.6231 3.37646 15.4326L21.7552 21.1593V42.2683Z",
    fill: "#3BAACF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96888 36.0749C9.96888 36.0749 15.5624 38.339 15.962 39.0715C16.3615 39.8039 16.3615 20.2266 16.3615 20.2266C16.3615 20.2266 8.70368 18.0957 8.03778 18.0957C8.03778 18.0957 10.3684 26.0199 9.96888 36.0749Z",
    fill: "#E9C243"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.7551 21.1592V24.6885L38.8686 18.8286C39.3348 17.3636 39.9341 15.9652 40.6 14.7666L21.7551 21.1592ZM4.57496 19.0949C4.24201 17.8297 3.84247 16.6311 3.30975 15.4325L21.6885 21.1592V24.6885L4.57496 19.0949Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84491 13.568L20.823 17.7632L41.7987 12.7023L21.2225 11.5703L1.84491 13.568Z",
    fill: "#4FC7E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84491 13.5674L3.37647 17.7625L20.823 22.6902V17.7625L1.84491 13.5674Z",
    fill: "#3BAACF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8227 22.6904C20.8227 22.6904 36.671 16.8305 40.5998 16.5642C40.5998 16.5642 40.8662 14.2335 41.7984 12.7686L20.8227 17.7628V22.6904Z",
    fill: "#076170"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.505 14.8326L11.3672 18.4951L15.6289 16.564L21.8218 14.6995L29.5462 15.6317L33.6082 16.4308L36.871 13.9004L7.505 14.8326Z",
    fill: "#F0AE11"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.629 16.5641L21.8218 14.6996L29.5462 15.6319L36.8711 13.9005L21.4223 12.4355L7.50507 14.8328L15.629 16.5641Z",
    fill: "#F0AE11"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50507 14.833V19.4943L15.2961 21.6252L15.629 16.5643L7.50507 14.833Z",
    fill: "#F8D048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5464 15.6317L29.6796 20.0932L36.3386 18.0955L36.8713 13.9004L29.5464 15.6317Z",
    fill: "#C47116"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3511 12.5027C25.3511 12.5027 25.3511 7.8414 29.8792 3.77943C29.8792 3.77943 27.149 4.77827 25.8173 4.51191C24.2191 4.24555 23.6864 2.31445 23.6864 2.31445C23.6864 2.31445 19.8242 10.7048 20.9562 11.7702C22.0882 12.9022 25.3511 12.5027 25.3511 12.5027Z",
    fill: "#EA9F07"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4242 15.2324C19.4242 15.2324 16.8272 9.90518 11.3003 7.10841C11.3003 7.10841 15.6286 6.70888 16.6275 6.17616C17.8927 5.57685 18.6252 3.91211 18.6252 3.91211C18.6252 3.91211 23.4196 12.3024 23.0201 13.5676C22.6205 14.8328 19.4242 15.2324 19.4242 15.2324Z",
    fill: "#F8D048"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2216 14.6329C22.2216 14.6329 18.1597 16.2311 12.9657 16.2311C2.04496 16.1645 0.513395 8.30692 11.3009 9.03941C20.1574 9.70531 22.2216 14.6329 22.2216 14.6329Z",
    fill: "#EA9F07"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4885 14.5669C21.4885 14.5669 26.283 14.9665 30.7445 13.8344C40.067 11.4372 36.6044 4.37871 27.8145 7.37525C20.6229 9.83907 21.4885 14.5669 21.4885 14.5669Z",
    fill: "#F0AE11"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2215 14.6334C22.2215 14.6334 19.6911 15.6323 16.4282 15.6323C9.63603 15.6323 8.63719 10.7046 15.3627 11.1707C20.8897 11.5703 22.2215 14.6334 22.2215 14.6334Z",
    fill: "#824000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2214 14.633C22.2214 14.633 25.5509 14.8994 28.6806 14.1003C35.2064 12.4356 32.7425 7.50792 26.6829 9.5722C21.6221 11.3035 22.2214 14.633 22.2214 14.633Z",
    fill: "#824000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubOffersgifticon);
export default __webpack_public_path__ + "static/media/hub-offersgifticon.60f53e717508c3332bc626ad9b1d4e27.svg";
export { ForwardRef as ReactComponent };